import React from 'react'
import NavBar from '../components/NavBar'

export default class About extends React.Component {
  render() {
    return (
      <div>
        <NavBar />
        <div>about</div>
      </div>
    )
  }
}
